module.exports = __webpack_public_path__ + "media/images/talent/feature-01-ce7c357b9af0fc967b26a9cf21d28ca1.svg";